import { render } from "./SliderHomeLogo.vue?vue&type=template&id=53eeeaec&scoped=true"
import script from "./SliderHomeLogo.vue?vue&type=script&lang=js"
export * from "./SliderHomeLogo.vue?vue&type=script&lang=js"

import "./SliderHomeLogo.vue?vue&type=style&index=0&id=53eeeaec&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/bedoya_group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53eeeaec"]])

export default __exports__